import React from "react";
import PropTypes from 'prop-types';
import $ from 'jquery';
import _ from 'lodash';
import moment from "moment";

import MonthView from "./../common/calendar/monthView";
import TimeTableView from "./../common/calendar/timeTableView";
import ActionTypes from "./../../actionTypes";
import *  as Misc from "./../../misc";
import Middleware from "./../../middleware";
import Analytics from './../../analytics';

export default class ConfirmationScheduleView extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  static propTypes = {
    cancel: PropTypes.func
  };

  state = {
    visible: false,
    selectedDate: moment(),
    time: 10,
    aptType: 'apt' // apt | home-estimate
  };

  componentDidMount() {
    $(document).on(ActionTypes.SHOW_SUMMARY, this.handleShowSummary);
  };

  componentWillUnmount() {
    $(document).off(ActionTypes.SHOW_SUMMARY, this.handleShowSummary);
  };

  handleShowSummary = (e, data) => {
    this.setState({visible: _.has(data, 'visible') ? data.visible : true});
  };

  /**
   *
   * @param date {moment}
   */
  handleMonthDayChange = (date) => {
    Analytics.sendDataEnteredEvent('calendar-date-change');
    this.setState({selectedDate: date});
  };

  handleTimeTableTimeChange = (time, aptType) => {
    Analytics.sendDataEnteredEvent('calendar-time-aptType-change');
    this.setState({
      time: time,
      aptType: aptType
    });
  };

  handleCancelClick = (e) => {
    Analytics.sendClickEvent('calendar-cancel');
    Misc.ignoreDefault(e);
    this.setState({visible: false});
    if (_.has(this.props, "cancel")) {
      this.props.cancel();
    }
  };

  handleScheduleClick = (e) => {
    Analytics.sendClickEvent('calendar-schedule');
    Misc.ignoreDefault(e);
    Middleware.scheduleCustomer(this.state.selectedDate.format('MM/DD/Y'), this.state.time * 100, this.state.aptType);
  };

  render() {
    if (!this.state.visible) {
      return null;
    }

    return (
      <div className="lightbox-container lightbox-container--confirmation">
        <div className="lightbox-wrapper">
          <div className="lightbox-header-container">
            <div className="lightbox-title-block">
              <h7>Quote Confirmation</h7>
              <p>Thank you for submitting your quote. Below you can schedule an appointment or a free
                in home estimate by selecting the month, day, and time that works best for your schedule.</p>
            </div>
            <div className="lightbox-fixed-block"/>
            <div className="lightbox-button-block">
              <div className="lightbox-save-button" onClick={this.handleScheduleClick}>Schedule</div>
              <div className="lightbox-cancel-button" onClick={this.handleCancelClick}>No Appointment</div>
            </div>
          </div>


          <div className="confirmation-content-wrapper">
            <div className="confirmation-container">
              <MonthView dateChanged={this.handleMonthDayChange} selectedDate={this.state.selectedDate}/>

              <TimeTableView date={this.state.selectedDate} timeChanged={this.handleTimeTableTimeChange}
                             time={this.state.time} aptType={this.state.aptType}/>
            </div>

            <div className="confirmation-bottom-text">A representative will contact you within 24 hours to confirm time
              and availability.
            </div>
          </div>
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/projectSummary/confirmationScheduleView.js